export const ru = {
    'duplicate-error':
        'При массовом изменении можно выбрать только одно изображение для каждого размера'
};
